import { makeStyles } from "@material-ui/core/styles";
import { useContext } from "react";
import { UserContext } from "../store/UserContextProvider";
import ApSidebar from "../base/ApSidebar";
import { ThemeContext } from "../store/ThemeContextProvider";

const useStyles = makeStyles({
  root: {
    color: "#fff",
    maxWidth: "calc(100vw - 66px)",
  },
  main: {
    minHeight: "calc(100vh - 136px)",
    padding: "1rem",
    margin: "1rem",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
  },
  lessWidth: {
    maxWidth: "calc(100vw - 240px)",
  },
});

const VerifyRoute = ({
  children,
  displaySidebar = true,
}: {
  children: any;
  displaySidebar?: boolean;
}) => {
  const context = useContext(UserContext);
  const { isUserAuthenticated = false } = context;
  const themeContext = useContext(ThemeContext);
  const { isDrawerOpen = false } = themeContext;
  const classes = useStyles();

  if (!isUserAuthenticated) {
    return <></>;
  }

  return (
    <>
      {displaySidebar ? (
        <ApSidebar>
          <div
            className={`${classes.root} ${
              isDrawerOpen ? classes.lessWidth : ""
            }`}
          >
            <main className={`${classes.main}`}>{children}</main>
          </div>
        </ApSidebar>
      ) : (
        children
      )}
    </>
  );
};

export default VerifyRoute;
